export default function DesktopTabs({

    tabs,

    active,

    setActive

}) {

    return (

        <div className="desktop-tabs-page">

            {tabs.map((tab, index) => (

                <button

                    key={tab.id}

                    className={active === index ? "active" : ""}

                    onClick={() => setActive(index)}

                >

                    {tab.title}

                </button>

            ))}

        </div>

    )

}